export default "__VITE_ASSET__Cxyl9M1X__"